import { FeedbackAnalysisModel } from './FeedbackAnalysisModel'

export class FeedbackResultsModel {
  public feedbackRequestId: string | null = null
  public feedbackAnalysis: FeedbackAnalysisModel | null = null

  constructor (feedbackRequestId: string | null = null, feedbackAnalysis: FeedbackAnalysisModel | null = new FeedbackAnalysisModel()) {
    this.feedbackRequestId = feedbackRequestId
    this.feedbackAnalysis = feedbackAnalysis
  }
}
